import React, { useState } from 'react';
import Hero from '../components/Hero';
import ServicesOverview from '../components/ServicesOverview';
import WhyUsSection from '../components/WhyUsSection';
import Facts from '../components/Facts';
import ProcessSteps from '../components/ProcessSteps';
import ContactModal from '../components/ContactModal';
import SEO from '../components/SEO';
import { ArrowRight } from 'lucide-react';

const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <div data-testid="home-page">
      <SEO 
        title="Logistikos ir sandėliavimo paslaugos Kaune | WSK Logistika"
        description="Profesionalios sandėliavimo, krovos ir 3PL logistikos paslaugos Kaune. Efektyvūs sprendimai smulkiam ir vidutiniam verslui. Gaukite pasiūlymą."
        keywords="logistika Kaune, sandėliavimas Kaune, 3PL paslaugos, krovos darbai, prekių komplektavimas, logistikos centras"
      />
      <Hero />
      <ServicesOverview />
      <WhyUsSection />
      <Facts />
      <ProcessSteps />
      
      {/* Final CTA Section */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Pasiruošę pradėti bendradarbiavimą?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Susisiekite su mumis ir gaukite individualų pasiūlymą jūsų verslui
          </p>
          <button
            onClick={() => setIsModalOpen(true)}
            className="inline-flex items-center bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-blue-50 transition-all shadow-xl hover:shadow-2xl group"
            data-testid="final-cta-button"
          >
            Susisiekti dabar
            <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </section>

      {/* Contact Modal */}
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default Home;